import { formatIntlPlan } from './currency-utils';

export interface DBCustomerSchema {
  paymentProvider?: string;
  customerId: string;
  orgId: string;
  email: string;
  name: string;
  currency: string;
  country: string;
  postalCode: string;
  state: string;
  balance: number;
  created: Date;
  delinquent: boolean;
  preferredLocales: string[];
  source: {
    sourceType: string;
    expiration: Date;
    funding: string;
    brand: string;
    country: string;
  };
  metadata: any;
}

export interface DBDiscountSchema {
  discountId: string;
  couponId: string;
  name: string;
  value: number;
  discountMethod: 'fixed' | 'percent';
  duration: 'forever' | 'repeating' | 'once';
  durationInMonths: number;
  start: Date;
  end: Date;
}

export interface DBPriceSchema {
  priceId: string;
  productId: string;
  nickname: string;
  active: boolean;
  billingSchema: string;
  amount: number;
  interval: string;
  intervalCount: number;
  type: string;
  tiers: any;
  tiersMode: string;
}

export interface DBSubscriptionItemSchema {
  id: string;
  quantity: number;
  price: DBPriceSchema;
}

export interface DBSubscriptionSchema {
  subId: string;
  email: string;
  orgId: string;
  orgName: string;
  status: string;
  start_date: Date;
  current_period_start: Date;
  current_period_end: Date;
  customer: string;
  created: Date;
  ended_at: Date;
  canceled_at: Date;
  quantity: number;
  currency: string;
  plan: any;
  trial: any;
  pause: any;
  sub_discount: DBDiscountSchema;
  cust_discount: DBDiscountSchema;
  paymentProvider: string;
  subscription_items: DBSubscriptionItemSchema[];
  reactivationExclusionId: string;
  metadata: any;
}

export function subscriptionPlanPrice(subscription: any) {
  const currency = subscription.currency || 'usd';
  const items = subscription.subscription_items;
  if (items?.length) {
    const first = items[0];
    const price = first.price;
    return formatIntlPlan(price.amount, currency, price.interval, price.intervalCount);
  }
  if (subscription.plan?.amount) {
    return formatIntlPlan(subscription.plan.amount, currency, subscription.plan.interval || 'month', subscription.plan.intervalCount || 1);
  }
  return '-';
}
export function subscriptionName(subscription: any) {
  return subscription.plan?.nickname || subscription.plan?.name || subscription.plan?.id;
}
